import { useContext, type ReactNode } from "react";
import { PAGE_WORDING } from "@shared-core/domain/supplier-portal-wording";
import { SupplierBrandContext } from "./SupplierBrandContext";

/** The portal's top bar: the brand, and on the right either Sign in (a link) or who is signed in. */
export function SupplierHeader({ right }: { right: ReactNode }) {
  const supplierMark = useContext(SupplierBrandContext);
  return (
    <header className="border-b bg-card">
      <div className="mx-auto flex max-w-5xl items-center gap-4 px-4 py-3 sm:px-6">
        {supplierMark ?? (
          <span className="font-extrabold tracking-wider text-primary uppercase">
            {PAGE_WORDING.brand}
            <span className="ml-2 hidden text-sm font-medium tracking-normal text-muted-foreground normal-case sm:inline">
              {PAGE_WORDING.product}
            </span>
          </span>
        )}
        <span className="flex-1" />
        {right}
      </div>
    </header>
  );
}
